<template>
  <v-card>
    <v-card-title class="cardtitle mb-2 rounded-0">Motive</v-card-title>
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-select
          v-model="newData.suspectedReason"
          label="Suspected reason"
          :items="SuspectedReason"
          required
          :rules="required"
        />
        <v-select
          v-model="newData.suspectedTarget"
          label="Suspected target"
          :items="AnimalSpecies"
        />
        <v-text-field
          v-model="newData.details"
          label="Details"
        />
        <v-text-field
          v-model="newData.suspects"
          label="Suspects"
        />
        <v-select
          v-model="newData.confirmedReason"
          label="Confirmed reason"
          :items="StdChoices"
          required
          :rules="required"
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer/>
      <v-btn
        color="error"
        @click="cancel"
      >Cancel</v-btn>
      <v-btn
        color="grey lighten-2"
        @click="reset"
      >Clear</v-btn>
      <v-btn
        :disabled="!valid || !isDirty"
        color="#7eb09f"
        @click="validate"
      >Save
         <v-progress-circular color="biscuit" v-if="loading" indeterminate/>     
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { sync, get } from 'vuex-pathify'
import Motive from '@/models/motive.js'
import { SuspectedReason, AnimalSpecies, StdChoices } from '@/utils/selectoptions.js'

export default {
  props: {
    Motive: {
      type: Object,
      default: function () {
        return {}
      }
    },
    passed: {
      type: Boolean,
      default: false
    },
    entrycode: {
      type: Number
    }
  },
  data: function () {
    return {
      valid: false,
      loading: false,
      required: [
        v => !!v || 'Field is required'
      ],
      StdChoices: StdChoices,
      AnimalSpecies: AnimalSpecies,
      SuspectedReason: SuspectedReason
    };
  },
  methods: {
    validate () {
      this.loading = true
      if (this.$refs.form.validate()) {
        this.$store.dispatch('incidentsnew/updMotive', {entrycode: this.entrycode, payload: this.newData})
          .then(() => {
            this.loading = false
            this.initData = {...this.newData}
          })
          .catch(e => {
            console.log('WE GOT THE ERROR')
            console.log(this.$store.state.incidentsnew.error)
          })  // FIXME
      } else {
        this.loading = false
      }
    },
    cancel () {
      this.$router.back();
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    }
  },
  created () {
    this.newData = new Motive()
  },
  mounted () {
    if (this.passed) {
      this.initData = {...this.Motive}
      this.newData = this.Motive
      this.$refs.form.resetValidation()
    }
  },
  computed: {
    ...sync('form', [
      'initData',
      'newData'
    ]),
    ...get('form', [
      'isDirty'
    ])
  }
};
</script>

<style scoped>
.cardtitle {
  background-color: #7eb09f;
}
</style>